// extracted by mini-css-extract-plugin
export default {"tabs":"App_tabs__JDwN6","tab":"App_tab__gjf8-","active":"App_active__L1enj"};